import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash";

export default class extends Controller {
  static targets = ["query", "results"];

  connect() {
    this.queryTarget.addEventListener("input", debounce(this.search.bind(this), 300));
  }

  async search() {
    const query = this.queryTarget.value.trim();

    if (query.length < 3) {
      this.hideResults();
      return;
    }

    try {
      const response = await fetch(`/search?query=${encodeURIComponent(query)}`);
      const html = await response.text();

      if (html.trim() === "") {
        this.hideResults();
      } else {
        this.resultsTarget.innerHTML = html;
        this.showResults();
      }
    } catch (error) {
      console.error("Search error:", error);
      this.hideResults();
    }
  }

  showResults() {
    this.resultsTarget.classList.add("dropdown-visible")
  }

  hideResults() {
    this.resultsTarget.classList.remove("dropdown-visible");
  }

  select(event) {
    const selectedText = event.target.textContent;
    this.queryTarget.value = selectedText;
    this.hideResults();
  }
}
